module.exports = __webpack_public_path__ + "static/media/Esquites con mayonesa.2dc38835.webp";